import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";

import { formatString } from "@/core/utils/helpers";
import {
  CreateEmployeeGradeDto,
  UpdateEmployeeGradeDto,
} from "../dtos/employeeGrade.dtos";
import { EMPLOYEE_GRADES_API_PATHS } from "../constants";

class EmployeeGradeService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getEmployeeGrades(
    organizationId: string,
    isActive?: boolean,
  ): Promise<ICoreResponse> {
    const basePath = formatString(
      EMPLOYEE_GRADES_API_PATHS.GET_EMPLOYEE_GRADES,
      organizationId,
    );
    const url =
      typeof isActive === "boolean"
        ? `${basePath}?is_active=${isActive}`
        : basePath;
    return this.restClient.get(url);
  }

  public createEmployeeGrade(
    organizationId: string,
    body: CreateEmployeeGradeDto,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(
        EMPLOYEE_GRADES_API_PATHS.CREATE_EMPLOYEE_GRADE,
        organizationId,
      ),
      body,
    );
  }

  public updateEmployeeGrade(
    organizationId: string,
    body: UpdateEmployeeGradeDto,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(
        EMPLOYEE_GRADES_API_PATHS.UPDATE_EMPLOYEE_GRADE,
        organizationId,
      ),
      body,
    );
  }

  public patchEmployeeGradeStatus(
    organizationId: string,
    employeeGradeId: string,
    isActive: boolean,
  ): Promise<ICoreResponse> {
    return this.restClient.patch(
      formatString(
        EMPLOYEE_GRADES_API_PATHS.PATCH_EMPLOYEE_GRADE_STATUS,
        organizationId,
        employeeGradeId,
      ),
      {
        is_active: isActive,
      },
    );
  }

  public deleteEmployeeGrade(
    organizationId: string,
    publicId: string,
  ): Promise<ICoreResponse> {
    return this.restClient.delete(
      formatString(
        EMPLOYEE_GRADES_API_PATHS.DELETE_EMPLOYEE_GRADE,
        organizationId,
        publicId,
      ),
      "",
    );
  }
}

export default EmployeeGradeService;
